export const HUMAN_DATE_FORMAT = 'dd/MM/yyyy' // Based on date-fns pattern
export const HUMAN_MONTH_DATE_FORMAT = 'MM/yyyy' // Based on date-fns pattern
export const ISO_LOCAL_DATE_FORMAT = 'yyyy-MM-dd' // Based on date-fns pattern

export const enum DateFormatError {
  INVALID_ISO_LOCAL_DATE = 'Invalid ISO Local Date', // ISO 8601 format with local date part only
  INVALID_ISO_DATE = 'Invalid ISO Date', // ISO 8601 format with local date (and local time (and offset))
  INVALID_HUMAN_DATE = 'Invalid Human Date',
}
